import React from 'react';
import { connect } from 'react-redux';
import { notify, push, showAddCard, clearDownloadedMaps } from 'actions';
import {
  Container,
  LoadingSpinner,
  PlanCalculator
} from 'components';
import {
  getCustomer,
  fetchPlans,
  fetchFeaturePlans,
  fetchRegionGeoJson,
  createSubscription,
  updateSubscription,
  cancelSubscription
} from 'api';
import {
  Panel,
  Button,
  ButtonGroup,
  Row,
  Col
} from 'react-bootstrap';

class SubscriptionWizardContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching_data: true,
      saving_subscription: false,
      plans: [],
      subscriptions: null
    };

    this.handleError = this.handleError.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.saveMonthly = this.saveMonthly.bind(this);
    this.saveYearly = this.saveYearly.bind(this);

    this.mounted = false;
  }

  handleError(error) {
    console.log(error);
    this.props.notify({ message: error.message || error });
  }
  handleCreate(monthly_items, yearly_items) {
    if(!this.state.saving_subscription) {
      this.setState({ saving_subscription: true });

      return getCustomer()
      .then(customer => {
        if(!customer.default_source) {
          this.setState({ saving_subscription: false });
          this.props.showAddCard();
        }
        else {
          this.setState({ saving_subscription: true });
          return Promise.all([
            this.saveMonthly(monthly_items),
            this.saveYearly(yearly_items)
          ])
          .then(res => {
            this.setState({ saving_subscription: false });
            this.props.push({
              pathname: '/dashboard/summary',
              state: { show_subscription_success_prompt: true }
            });
          })
          .catch(e => {
            console.log(e);
            this.props.notify({ message: e.message || e });
            if(this.mounted) {
              this.setState({ saving_subscription: false });
            }
          });
        }
      });
    } else {
      this.props.push({
        pathname: '/dashboard/summary',
        state: { show_subscription_success_prompt: true }
      });
      return Promise.resolve();
    }
  }
  handleUpdate(monthly_items, yearly_items) {
    if(!this.state.saving_subscription) {
      this.setState({ saving_subscription: true });

      return Promise.all([
        this.saveMonthly(monthly_items),
        this.saveYearly(yearly_items)
      ])
      .then(res => {
        console.log(res);
        this.setState({ saving_subscription: false });
        this.props.push({
          pathname: '/dashboard/summary',
          state: { show_subscription_success_prompt: true }
        });
        this.props.clearDownloadedMaps();
      })
      .catch(e => {
        console.log(e);
        this.props.notify({ message: e.message || e });
        if(this.mounted) {
          this.setState({ saving_subscription: false });
        }
      });
      } else {
      this.props.push({
        pathname: '/dashboard/summary',
        state: { show_subscription_success_prompt: true }
      });
      return Promise.resolve();
    }
  }
  saveMonthly(monthly_items) {
    const monthly_subscription = this.props.subscriptions.subscriptions.find(s => s.interval == 'month');

    if(monthly_items.length > 0) {
      if(monthly_subscription) {
        return updateSubscription({ ...monthly_subscription, items: monthly_items });
      }
      else {
        return createSubscription({ items: monthly_items });
      }
    }
    else if(monthly_subscription) {
      return cancelSubscription(monthly_subscription._id);
    }
    else {
      return Promise.resolve();
    }
  }
  saveYearly(yearly_items) {
    const yearly_subscription = this.props.subscriptions.subscriptions.find(s => s.interval == 'year');

    if(yearly_items.length > 0) {
      if(yearly_subscription) {
        return updateSubscription({ ...yearly_subscription, items: yearly_items });
      }
      else {
        return createSubscription({ items: yearly_items });
      }
    }
    else if(yearly_subscription) {
      return cancelSubscription(yearly_subscription._id);
    }
    else {
      return Promise.resolve();
    }
  }
  componentDidMount() {
    this.mounted = true;
    fetchPlans({})
    .then(({ results: plans }) => {
      this.setState(() => ({ plans }));
      this.setState({
        fetching_data: false,
        subscriptions: (this.props.location.state || {}).subscriptions
      });
    })
    .catch(e => {
      this.props.notify({ message: e.message || e });
      if(this.mounted) {
        this.setState({ fetching_data: false });
      }
    });
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { page } = this.props.subscriptions.wizard;
    return (
      <Container title='Subscription Wizard' addLargeWidthPadding>
        <div className='subscription-wizard-container animated fadeInLeft'>
          <PlanCalculator
            plans={this.state.plans}
            fetching_data={this.state.fetching_data}
            handleCreate={this.handleCreate}
            handleUpdate={this.handleUpdate}
            handleError={this.handleError}
            subscriptions={this.state.subscriptions}
            saving_subscription={this.state.saving_subscription}
          />
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ subscriptions, users }) => ({ subscriptions, users });

export default connect(mapStateToProps, { notify, push, showAddCard, clearDownloadedMaps })(SubscriptionWizardContainer);



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/subscription-wizard-container.js